import { useState } from "react";
import { Check, ArrowRight, ArrowLeft, Plus, Trash2, Edit } from "lucide-react";
import Logo from "./Logo";
import StepIndicator from "./StepIndicator";

export default function StepThreeFAQ({
  formData,
  handleInputChange,
  handleNextStep,
  handlePrevStep,
  handleCancel,
}) {
  const [newQuestion, setNewQuestion] = useState("");
  const [newAnswer, setNewAnswer] = useState("");
  const [editingIndex, setEditingIndex] = useState(null);

  const handleAddFAQ = () => {
    if (newQuestion.trim() && newAnswer.trim()) {
      const newFAQs = [
        ...formData.faqs,
        { question: newQuestion.trim(), answer: newAnswer.trim() },
      ];
      handleInputChange("faqs", newFAQs);
      setNewQuestion("");
      setNewAnswer("");
    }
  };

  const handleEditFAQ = (index) => {
    setEditingIndex(index);
    setNewQuestion(formData.faqs[index].question);
    setNewAnswer(formData.faqs[index].answer);
  };

  const handleUpdateFAQ = () => {
    if (editingIndex !== null && newQuestion.trim() && newAnswer.trim()) {
      const updatedFAQs = formData.faqs.map((faq, index) =>
        index === editingIndex
          ? { question: newQuestion.trim(), answer: newAnswer.trim() }
          : faq
      );
      handleInputChange("faqs", updatedFAQs);
      setEditingIndex(null);
      setNewQuestion("");
      setNewAnswer("");
    }
  };

  const handleDeleteFAQ = (index) => {
    const filteredFAQs = formData.faqs.filter((_, i) => i !== index);
    handleInputChange("faqs", filteredFAQs);
  };

  return (
   <div className="min-h-screen flex items-start justify-center pt-1 p-4" style={{ backgroundColor: '#ffffff' }}>
      <div className="bg-white rounded-2xl   p-8 w-full max-w-md">
        <Logo />
        <StepIndicator currentStep={3} />

        <h2 className="text-xl font-semibold text-gray-900 mb-6">
          Frequently Asked Questions
        </h2>

        <div className="space-y-4 mb-6">
          {formData.faqs.map((faq, index) => (
            <div key={index} className="p-4 bg-gray-50 rounded-lg shadow-sm">
              <div className="flex justify-between items-start mb-2 gap-2">
                <div className="flex-1 min-w-0">
                  <h4 className="font-semibold text-gray-800 break-words overflow-wrap-anywhere">
                    Q: {faq.question}
                  </h4>
                  <p className="text-sm text-gray-600 mt-1 break-words overflow-wrap-anywhere">A: {faq.answer}</p>
                </div>
                <div className="flex space-x-2 flex-shrink-0">
                  <button
                    onClick={() => handleEditFAQ(index)}
                    className="text-blue-500 hover:text-blue-700"
                    aria-label="Edit FAQ"
                  >
                    <Edit size={16} />
                  </button>
                  <button
                    onClick={() => handleDeleteFAQ(index)}
                    className="text-red-500 hover:text-red-700"
                    aria-label="Delete FAQ"
                  >
                    <Trash2 size={16} />
                  </button>
                </div>
              </div>
            </div>
          ))}

          {/* Add/Edit FAQ Form */}
          <div className="p-4 bg-gray-100 rounded-lg space-y-3">
            <h3 className="font-semibold text-sm">
              {editingIndex !== null ? "Edit FAQ" : "Add New FAQ"}
            </h3>
            <textarea
              value={newQuestion}
              onChange={(e) => setNewQuestion(e.target.value)}
              placeholder="Enter question"
              rows="2"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 transition-all"
            />
            <textarea
              value={newAnswer}
              onChange={(e) => setNewAnswer(e.target.value)}
              placeholder="Enter answer"
              rows="3"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 transition-all"
            />
            <button
              onClick={editingIndex !== null ? handleUpdateFAQ : handleAddFAQ}
              className="w-full py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 transition-all"
            >
              {editingIndex !== null ? "Update" : "Add"}
            </button>
          </div>
        </div>

        <button
          onClick={handleNextStep}
          className="w-full py-4 bg-gradient-to-r from-green-500 to-teal-600 text-white rounded-lg hover:from-green-600 hover:to-teal-700 transition-all flex items-center justify-center space-x-2"
        >
          <span>Next Step</span>
          <ArrowRight size={20} />
        </button>

        <div className="flex justify-between items-center mt-4">
          <button
            onClick={handlePrevStep}
            className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 transition-colors"
          >
            <ArrowLeft size={20} />
            <span>Back</span>
          </button>
          <button
            onClick={handleCancel}
            className="py-3 px-4 text-red-600 rounded-lg hover:bg-gray-100 transition-colors"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}